"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var qs = require("qs");
var uuid_1 = require("uuid");
var Util = /** @class */ (function () {
    function Util() {
    }
    Util.isBrowser = function () {
        return typeof window !== "undefined";
    };
    Util.createId = function () {
        return uuid_1.v4();
    };
    Util.slugMatch = function (slug, pageContext, exact) {
        var path = pageContext.url.pathname;
        if (slug === "index") {
            return path === "/";
        }
        if (exact) {
            return path.endsWith("/" + slug);
        }
        return (path + "/").includes("/" + slug + "/");
    };
    Util.getQueryParam = function (param) {
        if (Util.isBrowser()) {
            var obj = qs.parse(window.location.search, {
                ignoreQueryPrefix: true,
            });
            if (param in obj) {
                return obj[param];
            }
        }
        return "";
    };
    Util.unescapeScriptTags = function (text) {
        return text
            .replace(/_scriptstart_/g, "<script>")
            .replace(/_scriptend_/g, "</script>");
    };
    return Util;
}());
exports.default = Util;
//# sourceMappingURL=Util.js.map